/** Read-only view of the public env vars the running build was compiled with. */
export function EnvironmentTab() {
  const rows: [string, string | undefined][] = [
    ["NEXT_PUBLIC_ENV", process.env.NEXT_PUBLIC_ENV],
    ["NEXT_PUBLIC_CUSTOMER", process.env.NEXT_PUBLIC_CUSTOMER],
    ["NEXT_PUBLIC_SNID", process.env.NEXT_PUBLIC_SNID],
  ];

  return (
    <div className="space-y-2 text-xs">
      <dl className="divide-y divide-neutral-100">
        {rows.map(([key, value]) => (
          <div key={key} className="flex justify-between gap-4 py-1">
            <dt className="font-mono text-neutral-600">{key}</dt>
            <dd className="font-mono text-neutral-900">{value ?? "—"}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
